import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LockIcon from '@mui/icons-material/Lock';
import SavingsIcon from '@mui/icons-material/Savings';

export const BannerInfoBalanceIa = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA',
        borderRadius: 3,
        border: '1px solid #EAEAFF',
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
        <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
          <AccountBalanceWalletIcon sx={{ color: '#696CFF', fontSize: 32 }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
          >
            ¿Qué es el Balance de Créditos?
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 500, maxWidth: '80%' }}
          >
            Desde este módulo puedes visualizar el estado actual de los créditos de los clientes. Es
            de uso exclusivo para consulta y proporciona un control detallado sobre cómo se están
            consumiendo los servicios de inteligencia artificial.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <AssessmentIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Consumo de Créditos
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Supervisa los créditos consumidos hoy, en el mes actual y el consumo total histórico
              por cada suscripción.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <SavingsIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Créditos Disponibles
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Conoce exactamente la cantidad de créditos libres y utilizables que le quedan al
              cliente de su suscripción vigente.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <LockIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Créditos Reservados
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Visualiza los créditos que se encuentran actualmente bloqueados por peticiones en
              proceso o reservadas del sistema.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
